import { LOGIN_SUCCESS, UPDATE_PROFILE } from "../constants";

const initialState = {
  token: null,
  id: null,
  name: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default authReducer;
